var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",staticStyle:{"display":"none"},attrs:{"type":"file","multiple":_vm.multiple,"accept":_vm.accept},on:{"input":_vm.onFilePicked}})}
var staticRenderFns = []

export { render, staticRenderFns }